'use client';

import { Box } from '@mui/material';
import { FC } from 'react';

import { usePageContext } from '@abg/web-core/context/page/client-provider';

import { useTabTitleContext } from '../../tabs.context';

import { TabItemProperties } from './tabitem.types';

export const TabItem: FC<TabItemProperties> = ({
  aemAttributes,
  model,
  children = null,
}) => {
  const { tabTitle } = model;
  const { selectedTabTitle, showAllTabsInAuthorMode } = useTabTitleContext();
  const { config } = usePageContext();

  // to be able to configure all the tabs in author mode
  const isAuthorMode = config.app?.runmode === 'author';
  const showAllTabs = isAuthorMode && showAllTabsInAuthorMode;

  return (
    <Box {...aemAttributes} data-testid="tabs-item" data-aue-type="container">
      {(selectedTabTitle === tabTitle || showAllTabs) && <Box>{children}</Box>}
    </Box>
  );
};
